/** /api/groups 客户端。 */

import { apiGet, apiSend } from "./client";

export interface GroupMember {
  open_id: string;
  name: string | null;
}

export interface Group {
  id: number;
  name: string;
  created_at: string;
  members: GroupMember[];
}

export function listGroups(): Promise<Group[]> {
  return apiGet<Group[]>("/api/groups");
}

export function createGroup(name: string, members: GroupMember[]): Promise<Group> {
  return apiSend<Group>("/api/groups", "POST", { name, members });
}

export interface GroupPatch {
  name?: string;
  add_members?: GroupMember[];
  remove_member_open_ids?: string[];
}

export function patchGroup(id: number, patch: GroupPatch): Promise<Group> {
  return apiSend<Group>(`/api/groups/${id}`, "PATCH", patch);
}

export function deleteGroup(id: number): Promise<void> {
  return apiSend<void>(`/api/groups/${id}`, "DELETE");
}
